import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { Account, PlatformAccount } from './accounts.types';

@Injectable({ providedIn: 'root' })
export class AccountsService {
  private readonly _httpClient = inject(HttpClient);
  private _accounts = new BehaviorSubject<Account[]>([]);
  private _accountsPlatform = new BehaviorSubject<PlatformAccount[]>([]);

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Get Accounts
   */
  getAccounts(): Observable<Account[]> {
    const params = { page: '1', limit: '500' };
    return this._httpClient.get<{ objects: Account[] }>(`${environment.engineUrl}/account`, { params }).pipe(
      map((response) => {
        const accounts = response.objects || [];
        this._accounts.next(accounts);
        return accounts;
      })
    );
  }

  /**
   * Get All Accounts
   */
  getAllAccounts(): Observable<PlatformAccount[]> {
    return this._httpClient.get<{ content: PlatformAccount[] }>(`${environment.platformUrl}/accounts?size=500`).pipe(
      map((response) => {
        const accounts = response.content || [];
        this._accountsPlatform.next(accounts);
        return accounts;
      })
    );
  }

  getAccontsLocal(): Observable<Account[]> {
    return this._accounts.asObservable();
  }

  /**
   * Create a new accounts
   * @param account
   */
  createAccount(account: Partial<Account>): Observable<Account> {
    return this._httpClient.post<Account>(`${environment.engineUrl}/account`, account).pipe(
      map((response) => {
        return response;
      })
    );
  }

  /**
   * Edit Account
   * @param uid
   * @param account
   */
  editAccount(uid: string, account: Partial<Account>): Observable<Account> {
    return this._httpClient.put<Account>(`${environment.engineUrl}/account/${uid}`, account).pipe(
      map((response) => {
        const accounts = this._accounts.getValue();
        const index = accounts.findIndex(acc => acc._id === uid);
        accounts[index] = { ...accounts[index], ...account };
        this._accounts.next([...accounts]);
        return response;
      })
    );
  }
}
